import { useCallback, useState } from "react";
import { fetchBomData } from "../common/services";

const useFetchBomChildren = ({ houseId, viewId }) => {
  const [loading, setLoading] = useState(false);

  const fetchBomChildren = useCallback(
    async ({ objectId, inObject = false, withLoader = false }) => {
      try {
        withLoader && setLoading(true);
        const bomObjects = await fetchBomData(houseId, viewId, objectId);
        if (inObject) {
          return bomObjects.reduce(
            (bomChildrens, bomObject) => ({
              ...bomChildrens,
              [bomObject.objectid]: bomObject,
            }),
            {}
          );
        }
        return bomObjects;
      } catch (error) {
        console.error("fetchBomChildren ", error);
        throw error;
      } finally {
        withLoader && setLoading(false);
      }
    },
    [houseId, viewId]
  );

  return { loading, fetchBomChildren };
};

export default useFetchBomChildren;
